import rightAudio from '../assets/audio/right_answer.mp3';
import wrongAudio from '../assets/audio/wrong-answer.mp3';

export const audioAnswer=[new Audio(rightAudio),new Audio(wrongAudio)]